import { AbstractBlockFactory } from '../block/AbstractBlockFactory';
import { BlockType, ComponentSettings, NewBlockContextType } from '@report-content';
import { YNValues } from 'tools/types';

// Fields added after the component shipped — existing saved blocks won't have them in settings.
export const llmAiInsightDefaults: Pick<
    ComponentSettingsLlm,
    'resources' | 'only_when_significant_ind' | 'fallback_message' | 'generation_mode' | 'primary_resource'
> = {
    resources: [],
    only_when_significant_ind: 'N',
    fallback_message: '',
    generation_mode: 'pregenerate',
    primary_resource: '',
};

export class BlockFactoryLlm extends AbstractBlockFactory<ComponentSettingsLlm> {
    public getNewBlock({
        nextUId,
        nextSortOrder,
        datasetFields,
    }: NewBlockContextType): BlockType<ComponentSettingsLlm> {
        const uid = 'block_uid_' + nextUId;
        return {
            // TODO:
            component: {
                datasetRendererBlockComponentId: nextUId,
                datasetRendererBlockId: nextUId,
                datasetRendererComponentId: nextUId,
                displayOrder: nextSortOrder,
                internalName: 'llm',
                settings: {
                    groupFilter: { operator: 'AND', rules: [] },
                    component_name: 'LLM Component',
                    uid: uid,
                    internal_name: 'llm',
                    title: '',
                    prompt: '',
                    height: 200,
                    show_in_viewer: 'Y',
                    is_preview_ind: 'N',
                    include_in_email: 'Y',
                    include_in_email_attachment: 'Y',
                    is_collapsed_ind: 'N',
                    isOnCreation: true,
                    ...llmAiInsightDefaults,
                },
            },
            // datasetRendererBlockId: number;
            displayOrder: nextSortOrder,
            // elementId: number;
            uid: uid,
        };
    }
}

export interface ComponentSettingsLlm extends ComponentSettings {
    uid: string;
    component_name: 'LLM Component';
    prompt: string;
    resources?: string[];
    only_when_significant_ind?: YNValues;
    fallback_message?: string;
    generation_mode?: 'pregenerate' | 'on_demand';
    primary_resource?: string;
}

export interface LlmAiEnvelope {
    status: 'success' | 'failure';
    failure_message: string | null;
    offer: { description: string; suggested_prompt: string } | null;
    result: Array<{ summary: string; details: string }>;
}

export interface LlmInitialDataResponse {
    response: string;
    ai: LlmAiEnvelope;
}
